export const LIBRARY_LIST = 'Library'
export const VIEW_LIST = 'View'
export const PRICE_LIST = 'Price List'
export const CSV_PRICE_LIST = 'CSV Price List'
